import {$get} from '../http';
import {baseUrl} from "@/request/global";

var api = baseUrl
export const broadcastcenterindex = (params) => {
    return $get(api+'/idsp-pc/invest-hh/broadcast-center-index',params)
}
